import React from 'react';

import { isTypingTarget } from '../../helpers/links_to_check_flow_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './UndoToast.scss';

/** The answer waiting out its undo window, and any save that failed with a way to retry it. */
const UndoToast = () => {
  const { pending, failure, isKeysOpen, undo, retry, clearFailure } = useLinksToCheckContext();

  useWindowKeydown(e => {
    if (!pending || e.repeat || isKeysOpen || isTypingTarget(e.target) || e.altKey) return;
    const isUndoKey = e.metaKey || e.ctrlKey ? e.key.toLowerCase() === 'z' : e.key.toLowerCase() === 'u';
    if (!isUndoKey) return;
    e.preventDefault();
    undo();
  });

  if (!pending && !failure) return null;

  return (
    <div className='links-to-check-toasts'>
      {failure && (
        <div className='ltc-toast failed' role='alert'>
          <span className='toast-text'>{failure.message}</span>
          <button type='button' className='toast-action' onClick={retry}>
            Retry
          </button>
          <button type='button' className='toast-close' aria-label='Dismiss' onClick={clearFailure}>
            ×
          </button>
        </div>
      )}
      {pending && (
        <div key={pending.id} className='ltc-toast' role='status'>
          <span className='toast-text'>{pending.label}</span>
          <button type='button' className='toast-action' onClick={undo}>
            Undo <span className='ltc-key'>U</span>
          </button>
          <span className='toast-countdown' />
        </div>
      )}
    </div>
  );
};

export default UndoToast;
